// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import "bootstrap/dist/css/bootstrap.min.css";
// import {
//   getExercise,
//   createExercise,
//   updateExercise,
//   deleteExercise,
// } from "../../actions/exerciseAction";
// import {
//   listExerciseTemplates,
//   deleteExerciseTemplate,
//   createExerciseTemplate,
//   updateExerciseTemplate,
//   getExerciseTemplateById,
// } from "../../actions/exerciseTemplateAction";
// import { EXERCISE_TEMPLATE_RESET } from "../../actions/types";
// import { imgUrl } from "../../actions/types";

// const ExerciseManager = () => {
//   const dispatch = useDispatch();

//   const { exerciseList, hospitalID } = useSelector((state) => state.exercise);

// const { 
//   templates, 
//   success: templateSuccess, 
//   templateDetails,
//   loadingDetails   
// } = useSelector((state) => state.exerciseTemplates);
//   const [activeTab, setActiveTab] = useState("list");
//   const [selectedExercise, setSelectedExercise] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [showTemplateModal, setShowTemplateModal] = useState(false);
//   const [isEditingTemplate, setIsEditingTemplate] = useState(false);
//   const [selectedTemplate, setSelectedTemplate] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [templateFormData, setTemplateFormData] = useState({
//     id: "",
//     template_name: "",
//     note: "",
//     exercise_ids: [],
//   });
//   // Form State
//   const [newExercise, setNewExercise] = useState({
//     title: "",
//     description: "",
//     exercise_type: "",
//     steps: [],
//   });
//   const [currentStep, setCurrentStep] = useState({
//     step_title: "",
//     description: "",
//     duration_seconds: "",
//     image: null,
//   });

//   // API Call on Mount
//   // useEffect(() => {
//   //   dispatch(getExercise());
//   // }, [dispatch]);
//   useEffect(() => {
//     dispatch(getExercise());
//     dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
//   }, [dispatch, hospitalID]);
//   // useEffect(() => {
//   //   if (templateSuccess) {
//   //     setShowTemplateModal(false);
//   //     dispatch({ type: EXERCISE_TEMPLATE_RESET });
//   //     dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
//   //     alert("Template saved successfully!");
//   //   }
//   // }, [templateSuccess, dispatch, hospitalID]);
//   // Image helper function for UI
//   useEffect(() => {
//   if (templateSuccess) {
//     setShowTemplateModal(false);

//     setActiveTab("templates"); 
//     dispatch({ type: EXERCISE_TEMPLATE_RESET });
    
//     dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
    
//     alert("Template saved successfully!");
//   }
// }, [templateSuccess, dispatch, hospitalID]);
// const resetTemplateForm = () => {
//   setTemplateFormData({
//     id: "",
//     template_name: "",
//     note: "",
//     exercise_ids: [],
//   });
//   setIsEditingTemplate(false);
// };
//   const getDisplayImage = (img) => {
//     if (!img) return "https://via.placeholder.com/150";
//     if (img instanceof File) return URL.createObjectURL(img); // Local Preview
//     return `${imgUrl}${img}`; // API URL
//   };

//   // --- HANDLERS ---
//   // const handleEditTemplate = (temp) => {
//   //   setIsEditingTemplate(true);
//   //   setTemplateFormData({
//   //     id: temp.id,
//   //     template_name: temp.template_name,
//   //     note: temp.note,

//   //     exercise_ids: temp.exercises
//   //       ? temp.exercises.map((ex) => ex.exercise_id)
//   //       : [],
//   //   });
//   //   setActiveTab("createTemplate");
//   // };
// // const handleEditTemplate = (temp) => {
// //   setIsEditingTemplate(true);
  
 
// //   const selectedIds = temp.exercises
// //     ? temp.exercises.map((ex) => Number(ex.exercise_id || ex.id)) 
// //     : [];

// //   setTemplateFormData({
// //     id: temp.id,
// //     template_name: temp.template_name,
// //     note: temp.note,
// //     exercise_ids: selectedIds, 
// //   });
  
// //   setActiveTab("createTemplate");
// // };
// const handleEditTemplate = (temp) => {
//   setIsEditingTemplate(true); 
  
//   const selectedIds = temp.exercises
//     ? temp.exercises.map((ex) => Number(ex.exercise_id || ex.id)) 
//     : [];

//   setTemplateFormData({
//     id: temp.id,
//     template_name: temp.template_name,
//     note: temp.note,
//     exercise_ids: selectedIds, 
//   });
  
//   setActiveTab("createTemplate"); 
// };
//   const handleDeleteTemplate = (id) => {
//     if (window.confirm("Delete this template?")) {
//       dispatch(deleteExerciseTemplate(id));
//     }
//   };
//   // const handleToggleExerciseInTemplate = (id) => {
//   //   const currentIds = templateFormData.exercise_ids || [];
//   //   const isSelected = currentIds.includes(id);

//   //   if (isSelected) {
//   //     setTemplateFormData({
//   //       ...templateFormData,
//   //       exercise_ids: currentIds.filter((exId) => exId !== id),
//   //     });
//   //   } else {
//   //     setTemplateFormData({
//   //       ...templateFormData,
//   //       exercise_ids: [...currentIds, id],
//   //     });
//   //   }
//   // };
//   const handleToggleExerciseInTemplate = (id) => {
//   const currentIds = templateFormData.exercise_ids || [];
//   const targetId = Number(id); 
  
//   const isSelected = currentIds.some(existingId => Number(existingId) === targetId);

//   if (isSelected) {
//     setTemplateFormData({
//       ...templateFormData,
//       exercise_ids: currentIds.filter((exId) => Number(exId) !== targetId),
//     });
//   } else {
//     setTemplateFormData({
//       ...templateFormData,
//       exercise_ids: [...currentIds, targetId],
//     });
//   }
// };
//   const handleSaveTemplate = () => {
//     if (!templateFormData.template_name) return alert("Template name required");
//     // Payload create karein
//     const payload = {
//       template_name: templateFormData.template_name,
//       note: templateFormData.note,
//       exercise_ids: templateFormData.exercise_ids, // Correct key name
//       hospital_id: hospitalID,
//       status: "Active",
//     };

//     if (isEditingTemplate) {
//       payload.id = templateFormData.id;
//       dispatch(updateExerciseTemplate(payload));
//     } else {
//       dispatch(createExerciseTemplate(payload));
//     }
//   };
//   const handleDeleteExercise = (id) => {
//     if (window.confirm("Are you sure you want to delete this exercise?")) {
//       dispatch(deleteExercise({ id: id })).then(() => {
//         dispatch(getExercise());
//       });
//     }
//   };

//   const handleEditExercise = (ex) => {
//     setIsEditing(true);
//     setEditId(ex.id);
//     setNewExercise({
//       title: ex.title,
//       description: ex.description,
//       exercise_type: ex.exercise_type || "",
//       steps: ex.steps,
//     });
//     setActiveTab("create");
//   };

//   const handleAddStep = () => {
//     if (!currentStep.step_title || !currentStep.description)
//       return alert("Fill step details");
//     setNewExercise({
//       ...newExercise,
//       steps: [
//         ...newExercise.steps,
//         { ...currentStep, step_number: newExercise.steps.length + 1 },
//       ],
//     });
//     setCurrentStep({
//       step_title: "",
//       description: "",
//       duration_seconds: "",
//       image: null,
//     });
//   };

//   const handleSaveExercise = () => {
//     if (!newExercise.title) return alert("Title is required");

//     const formData = new FormData();
//     formData.append("title", newExercise.title);
//     formData.append("description", newExercise.description);
//     formData.append("exercise_type", newExercise.exercise_type);
//     formData.append("hospitalID", hospitalID);

//     newExercise.steps.forEach((step, index) => {
//       formData.append(`steps[${index}][step_title]`, step.step_title);
//       formData.append(`steps[${index}][description]`, step.description);
//       formData.append(
//         `steps[${index}][duration_seconds]`,
//         step.duration_seconds,
//       );
//       formData.append(`steps[${index}][step_number]`, index + 1);
//       if (step.image) formData.append(`steps[${index}][image]`, step.image);
//     });

//     if (isEditing) {
//       formData.append("id", editId);
//       dispatch(updateExercise(formData)).then((res) => {
//         if (res.data.success) {
//           alert("Exercise Updated!");
//           resetForm();
//         }
//       });
//     } else {
//       dispatch(createExercise(formData)).then((res) => {
//         if (res.data.success) {
//           alert("Exercise Created!");
//           resetForm();
//         }
//       });
//     }
//   };

//   const resetForm = () => {
//     setNewExercise({
//       title: "",
//       description: "",
//       exercise_type: "",
//       steps: [],
//     });
//     setIsEditing(false);
//     setEditId(null);
//     setActiveTab("list");
//     dispatch(getExercise());
//   };

//   const handlePrint = () => {
//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Exercise - ${selectedExercise.title}</title>
//           <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
//           <style>
//             @page { size: A4; margin: 10mm; }
//             body { padding: 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background: #fff; }
//             .exercise-header { text-align: center; margin-bottom: 20px; border-bottom: 3px solid #00acc1; padding-bottom: 10px; }
//             .exercise-header h2 { color: #00acc1; margin-bottom: 5px; font-weight: bold; }
            
//             /* Main Step Row Container */
//             .step-row { 
//               display: flex; 
//               border: 1px solid #ddd; 
//               margin-bottom: 10px; 
//               height: 175px; /* Fixed height to fit 5 steps per A4 page */
//               break-inside: avoid; 
//               overflow: hidden;
//             }

//             /* 40% Image Section */
//             .step-image-box { 
//               flex: 0 0 40%; 
//               max-width: 40%; 
//               background: #f8f9fa;
//               border-right: 1px solid #ddd;
//             }
//             .step-image-box img { 
//               width: 100%; 
//               height: 100%; 
//               object-fit: contain; 
//             }

//             /* 60% Content Section */
//             .step-details-box { 
//               flex: 0 0 60%; 
//               max-width: 60%; 
//               padding: 12px; 
//               position: relative;
//               display: flex;
//               flex-direction: column;
//             }

//             .step-number-badge {
//               background: #00acc1;
//               color: white;
//               padding: 2px 8px;
//               border-radius: 4px;
//               font-size: 12px;
//               font-weight: bold;
//               margin-bottom: 5px;
//               display: inline-block;
//             }

//             .duration-tag { 
//               position: absolute; 
//               top: 12px; 
//               right: 12px; 
//               background: #e0f7fa; 
//               color: #006064;
//               font-weight: bold;
//               padding: 2px 8px; 
//               border-radius: 4px; 
//               font-size: 11px; 
//             }

//             .step-title { 
//               font-size: 16px; 
//               font-weight: bold; 
//               margin-top: 5px;
//               color: #333;
//               white-space: nowrap;
//               overflow: hidden;
//               text-overflow: ellipsis;
//             }

//             .step-desc { 
//               font-size: 12.5px; 
//               color: #555; 
//               line-height: 1.4;
//               margin-top: 5px;
//               display: -webkit-box;
//               -webkit-line-clamp: 4; /* Max lines to show */
//               -webkit-box-orient: vertical;
//               overflow: hidden;
//             }
//           </style>
//         </head>
//         <body>
//           <div class="exercise-header">
//             <h2>${selectedExercise.title}</h2>
//             <p class="text-muted small">${selectedExercise.description}</p>
//           </div>
//           ${selectedExercise.steps
//             .map(
//               (step, index) => `
//             <div class="step-row">
//               <div class="step-image-box">
//                 <img src="${getDisplayImage(step.image)}">
//               </div>
//               <div class="step-details-box">
//                 <span class="duration-tag">${step.duration_seconds} Seconds</span>
//                 <span class="step-number-badge">Step ${index + 1}</span>
//                 <div class="step-title">${step.step_title}</div>
//                 <p class="step-desc">${step.description}</p>
//               </div>
//             </div>
//           `,
//             )
//             .join("")}
//           <script>
//             setTimeout(() => { 
//               window.print(); 
//               window.close(); 
//             }, 750);
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   };
//   const handlePrintTemplate = () => {
//   const data = templateDetails?.data || templateDetails;
//   if (!data) return;

//   const printWindow = window.open("", "_blank");
  
//   const exercisesHtml = data.exercises?.map((ex, exIdx) => `
//     <div class="exercise-section" style="break-after: page; margin-bottom: 30px;">
//       <!-- Exercise Header -->
//       <div style="background: #f8f9fa; border-left: 5px solid #00acc1; padding: 15px; margin-bottom: 20px;">
//         <h2 style="color: #00acc1; margin: 0; font-size: 22px;">${exIdx + 1}. ${ex.exercise_title || ex.title}</h2>
//         <div style="color: #666; font-size: 14px; margin-top: 5px;">Type: ${ex.exercise_type || 'General'}</div>
//         <p style="font-size: 14px; color: #444; margin-top: 8px;">${ex.description || ""}</p>
//       </div>

//       <!-- Steps List -->
//       ${ex.steps?.map((step, index) => `
//         <div class="step-row" style="display: flex; border: 1px solid #ddd; margin-bottom: 12px; min-height: 160px; break-inside: avoid;">
//           <!-- 40% Image Section -->
//           <div style="flex: 0 0 40%; background: #fff; display: flex; align-items: center; justify-content: center; border-right: 1px solid #ddd; padding: 5px;">
//             <img src="${getDisplayImage(step.image)}" style="max-width: 100%; max-height: 150px; object-fit: contain;">
//           </div>
//           <!-- 60% Content Section -->
//           <!-- 60% Content Section -->
// <div style="flex: 0 0 60%; max-width: 60%; padding: 12px; display: flex; flex-direction: column; font-family: sans-serif; box-sizing: border-box;">
    
//     <!-- Top Row: Step aur Sec ko ek line mein lane ke liye -->
//     <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
//         <span style="background: #00acc1; color: white; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; white-space: nowrap;">
//             Step ${index + 1}
//         </span>
//         <span style=" font-weight: bold; padding: 2px 6px; border-radius: 4px; font-size: 11px; white-space: nowrap;">
//             ${step.duration_seconds}s
//         </span>
//     </div>

//     <!-- Title Section -->
//     <div style="font-size: 15px; font-weight: bold; color: #333; line-height: 1.2; overflow: hidden; text-overflow: ellipsis;">
//         ${step.step_title}
//     </div>
    
//     <!-- Description Section -->
//     <p style="font-size: 12px; color: #555; line-height: 1.4; margin-top: 8px; margin-bottom: 0;">
//         ${step.description}
//     </p>
// </div>
//         </div>
//       `).join('')}
//     </div>
//   `).join('');

//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>Plan - ${data.template_name}</title>
//         <style>
//           @page { size: A4; margin: 15mm; }
//           body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; line-height: 1.4; }
//           .header-main { text-align: center; border-bottom: 4px double #00acc1; padding-bottom: 15px; margin-bottom: 25px; }
//           .footer { text-align: center; font-size: 12px; color: #888; margin-top: 30px; border-top: 1px solid #eee; padding-top: 10px; }
//         </style>
//       </head>
//       <body>
//         <div class="header-main">
//           <h1 style="margin: 0; color: #333; text-transform: uppercase; letter-spacing: 1px;">${data.template_name}</h1>
//           <p style="margin: 5px 0; color: #666; font-style: italic;">Note: ${data.note || "Please follow the instructions carefully."}</p>
//         </div>
        
//         ${exercisesHtml}

//         <div class="footer">
//           <p>Consult your doctor if you experience any pain during these exercises.</p>
//           <p>© Medisevas - Exercise Plan Generated on ${new Date().toLocaleDateString()}</p>
//         </div>

//         <script>
//           window.onload = () => {
//             setTimeout(() => { window.print(); window.close(); }, 1000);
//           };
//         </script>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();
// };
//   return (
//     <div className="appointments">
//       {/* Page Header */}
//       <div className="page-header filter-bar rounded no-print">
//         <div className="row align-items-center">
//           <div className="col">
//             <h4 className="page-title">Exercise Management</h4>
//             <ul className="breadcrumb">
//               <li className="breadcrumb-item">
//                 <Link to="/doctor/dashboard">Doctor Dashboard</Link>
//               </li>
//               <li className="breadcrumb-item active">Exercises</li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Tab Navigation */}
//       <ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded mt-4 no-print">
//         <li className="nav-item">
//           <button
//             className={`nav-link ${activeTab === "templates" ? "active" : ""}`}
//             onClick={() => setActiveTab("templates")}
//           >
//             Exercise Templates ({templates ? templates.length : 0})
//           </button>
//         </li>
//         <li className="nav-item">
//           <button
//             className={`nav-link ${activeTab === "list" ? "active" : ""}`}
//             onClick={() => setActiveTab("list")}
//           >
//             All Exercises ({exerciseList ? exerciseList.length : 0})
//           </button>
//         </li>
//       </ul>

//       <div className="tab-content mt-3">
//         {activeTab === "templates" && (
//           <div className="row">
//             <div className="col-12 mb-3 text-end">
       
//               <button
//   className="btn btn-info rounded-pill"
//   onClick={() => {
//     resetTemplateForm(); 
//     setActiveTab("createTemplate"); 
//   }}
// >
//   + Create New Template
// </button>
//             </div>
//             {templates?.map((temp) => (
//   <div className="col-md-6 col-lg-4 mb-4" key={temp.id}>
//     <div className="card h-100 shadow-sm border-0">
//       <div className="card-body d-flex flex-column">
        
//         {/* Upper Section: Title and Status Badge */}
//         <div className="d-flex justify-content-between mb-2">
//           <h5 className="fw-bold text-info mb-0">{temp.template_name}</h5>
//           <span className="badge bg-success">Active</span>
//         </div>

//         {/* Middle Section: Note/Description */}
//         <p className="text-muted small mb-3">
//           {temp.note ? (temp.note.length > 60 ? temp.note.substring(0, 60) + "..." : temp.note) : "No notes added"}
//         </p>

//         {/* Bottom Section (Fixed at bottom) */}
//         <div className="mt-auto pt-3 border-top">
//           <div className="d-flex justify-content-between align-items-center">
//             <span className="badge bg-info-light">
//               {temp.exercises?.length || 0} Exercises
//             </span>
//             <div className="d-flex gap-1">
//              <button
//   className="btn btn-sm btn-info"
//   onClick={() => {
//     dispatch(getExerciseTemplateById(temp.id)); 
//     setShowViewModal(true); 
//   }}
//   title="View Template"
// >
//   <i className="fas fa-eye"></i>
// </button>
//               <button
//                 className="btn btn-sm btn-warning text-white"
//                 onClick={() => handleEditTemplate(temp)}
//                 title="Edit"
//               >
//                 <i className="fas fa-edit"></i>
//               </button>
//               <button
//                 className="btn btn-sm btn-danger"
//                 onClick={() => handleDeleteTemplate(temp.id)}
//                 title="Delete"
//               >
//                 <i className="fas fa-trash"></i>
//               </button>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   </div>
// ))}
//           </div>
//         )}
//         {activeTab === "createTemplate" && (
//           <div className="card shadow-sm">
//             <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
//               <span className="fw-bold">
//                 {isEditingTemplate ? "Edit" : "Design"} Template
//               </span>
//               <button
//                 className="btn-close btn-close-white shadow-none"
//                 onClick={() => setActiveTab("templates")}
//               ></button>
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="col-md-6 mb-3">
//                   <label>Template Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={templateFormData.template_name}
//                     onChange={(e) =>
//                       setTemplateFormData({
//                         ...templateFormData,
//                         template_name: e.target.value,
//                       })
//                     }
//                   />
//                 </div>
//                 <div className="col-md-12 mb-3">
//                   <label>Note</label>
//                   <textarea
//                     className="form-control"
//                     value={templateFormData.note}
//                     onChange={(e) =>
//                       setTemplateFormData({
//                         ...templateFormData,
//                         note: e.target.value,
//                       })
//                     }
//                   ></textarea>
//                 </div>
//               </div>

//               <h6>Select Exercises:</h6>
//               <div
//                 className="row mt-2"
//                 style={{
//                   maxHeight: "300px",
//                   overflowY: "auto",
//                   border: "1px solid #eee",
//                   padding: "10px",
//                 }}
//               >
              
//                 {exerciseList?.map((ex) => {

//   const isChecked = templateFormData.exercise_ids?.some(
//     (id) => Number(id) === Number(ex.id)
//   );

//   return (
//     <div className="col-md-4 mb-2" key={ex.id}>
//       <div
//         className={`p-2 border rounded cursor-pointer ${
//           isChecked ? "bg-info-light border-info" : ""
//         }`}
//         onClick={() => handleToggleExerciseInTemplate(ex.id)}
//       >
//         <input
//           type="checkbox"
//           checked={isChecked} // यहाँ variable use करें
//           readOnly
//           className="me-2"
//         />
//         {ex.title}
//       </div>
//     </div>
//   );
// })}
//               </div>

//               <div className="text-end mt-4">
//                 <button
//                   className="btn btn-secondary me-2"
//                    onClick={() => {
//     resetTemplateForm(); 
//     setActiveTab("templates");
//   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-success px-5"
//                   onClick={handleSaveTemplate}
//                 >
//                   Save Template
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {/* TAB 1: LIST */}
//         {activeTab === "list" && (
//           <div className="row">
//             <div className="col-12 mb-3 text-end">
//               <button
//                 className="btn btn-info shadow-sm rounded-pill"
//                 onClick={() => {
//                   resetForm(); // Form reset logic
//                   setActiveTab("create"); // Create tab par shift
//                 }}
//               >
//                 <i className="fas fa-plus me-1"></i> Create New Exercise
//               </button>
//             </div>
//             {exerciseList &&
//   exerciseList.map((ex) => (
//     <div className="col-12 col-sm-6 col-lg-4 mb-4" key={ex.id}>
//       <div className="card h-100 shadow-sm border-0">
//         <div className="card-body d-flex flex-column">
          
//           {/* Upper Section: Title and Type Badge */}
//           <div className="d-flex justify-content-between mb-2">
//             <h5 className="fw-bold text-info mb-0">{ex.title}</h5>
//             {ex.exercise_type && (
//               <span className="badge bg-secondary-light text-secondary border">
//                 {ex.exercise_type}
//               </span>
//             )}
//           </div>

//           {/* Middle Section: Description */}
//           <p className="text-muted small mb-3">
//             {ex.description ? (ex.description.length > 80 ? ex.description.substring(0, 80) + "..." : ex.description) : "No description available"}
//           </p>

//           {/* Bottom Section (Fixed at bottom) */}
//           <div className="mt-auto pt-3 border-top">
//             <div className="d-flex justify-content-between align-items-center">
//               <span className="badge bg-info-light">
//                 {ex.steps?.length || 0} Steps
//               </span>
//               <div className="d-flex gap-1">
//                 <button
//                   className="btn btn-sm btn-info"
//                   onClick={() => setSelectedExercise(ex)}
//                   title="View"
//                 >
//                   <i className="fas fa-eye"></i>
//                 </button>
//                 <button
//                   className="btn btn-sm btn-warning text-white"
//                   onClick={() => handleEditExercise(ex)}
//                   title="Edit"
//                 >
//                   <i className="fas fa-edit"></i>
//                 </button>
//                 <button
//                   className="btn btn-sm btn-danger"
//                   onClick={() => handleDeleteExercise(ex.id)}
//                   title="Delete"
//                 >
//                   <i className="fas fa-trash"></i>
//                 </button>
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   ))}
//           </div>
//         )}

//         {/* TAB 2: CREATE */}
//         {activeTab === "create" && (
//           <div className="card shadow-sm">
//             <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
//               <span className="fw-bold">
//                 {isEditing ? "Edit Exercise" : "Exercise Designer"}
//               </span>
//               <button
//                 type="button"
//                 className="btn-close btn-close-white shadow-none"
//                 onClick={() => setActiveTab("list")}
//               ></button>
//             </div>
//             <div className="card-body">
//               <div className="row">
//                 <div className="col-md-6 mb-3">
//                   <label className="fw-bold">Exercise Title</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={newExercise.title}
//                     onChange={(e) =>
//                       setNewExercise({ ...newExercise, title: e.target.value })
//                     }
//                     placeholder="e.g. Knee Rehab"
//                   />
//                 </div>
//                 <div className="col-md-6 mb-3">
//                   <label className="fw-bold">Exercise Type</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="e.g. Strengthening, Yoga, Cardio..."
//                     value={newExercise.exercise_type || ""}
//                     onChange={(e) =>
//                       setNewExercise({
//                         ...newExercise,
//                         exercise_type: e.target.value,
//                       })
//                     }
//                   />
//                 </div>
//                 <div className="col-md-12 mb-3">
//                   <label className="fw-bold">Overall Description</label>
//                   <textarea
//                     className="form-control"
//                     rows="2"
//                     value={newExercise.description}
//                     onChange={(e) =>
//                       setNewExercise({
//                         ...newExercise,
//                         description: e.target.value,
//                       })
//                     }
//                   ></textarea>
//                 </div>
//               </div>

//               <div className="bg-light p-2 rounded mb-3 border shadow-sm">
//                 <div className="row g-2 align-items-start">
//                   {" "}
//                   {/* align-items-start use kiya taaki upar se aligned rahein */}
//                   {/* LEFT SIDE: Preview & Upload Button */}
//                   <div className="col-md-3 text-center border-end pe-3">
//                     <div
//                       className="border rounded bg-white d-flex align-items-center justify-content-center overflow-hidden mb-1 mx-auto"
//                       style={{ height: "125px", width: "100%" }} // Height thodi badhai taaki right side ke barabar dikhe
//                     >
//                       {currentStep.image ? (
//                         <img
//                           src={
//                             currentStep.image instanceof File
//                               ? URL.createObjectURL(currentStep.image)
//                               : currentStep.image
//                           }
//                           alt="Preview"
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             objectFit: "cover",
//                           }}
//                         />
//                       ) : (
//                         <div
//                           className="text-muted"
//                           style={{ fontSize: "10px" }}
//                         >
//                           <i className="fas fa-image fa-2x mb-1 opacity-25"></i>
//                           <p className="small mb-0">No Image</p>
//                         </div>
//                       )}
//                     </div>

//                     <input
//                       type="file"
//                       id="step-img-input"
//                       hidden
//                       accept="image/*"
//                       onChange={(e) => {
//                         if (e.target.files[0])
//                           setCurrentStep({
//                             ...currentStep,
//                             image: e.target.files[0],
//                           });
//                       }}
//                     />
//                     <button
//                       type="button"
//                       className="btn btn-info rounded-pill btn-sm w-100 py-1 mt-1"
//                       style={{ fontSize: "11px", height: "30px" }}
//                       onClick={() =>
//                         document.getElementById("step-img-input").click()
//                       }
//                     >
//                       <i className="fas fa-upload me-1"></i> Upload Image
//                     </button>
//                   </div>
//                   {/* RIGHT SIDE: Compact Fields with Matched Heights */}
//                   <div className="col-md-9">
//                     <div className="row g-2">
//                       {/* Title Field */}
//                       <div className="col-md-8">
//                         <input
//                           type="text"
//                           className="form-control form-control-sm"
//                           placeholder="Step Title"
//                           value={currentStep.step_title}
//                           onChange={(e) =>
//                             setCurrentStep({
//                               ...currentStep,
//                               step_title: e.target.value,
//                             })
//                           }
//                           style={{ height: "35px" }} // Fixed height
//                         />
//                       </div>

//                       {/* Duration Field */}
//                       <div className="col-md-4">
//                         <div className="input-group input-group-sm">
//                           {" "}
//                           {/* Container height fixed */}
//                           <input
//                             type="number"
//                             className="form-control form-control-sm"
//                             placeholder="Sec"
//                             value={currentStep.duration_seconds}
//                             onChange={(e) =>
//                               setCurrentStep({
//                                 ...currentStep,
//                                 duration_seconds: e.target.value,
//                               })
//                             }
//                             style={{ height: "35px" }} // Input height fixed
//                           />
//                           <span className="input-group-text py-0">sec</span>
//                         </div>
//                       </div>

//                       {/* Textarea Field (Height Increased) */}
//                       <div className="col-md-12">
//                         <textarea
//                           className="form-control form-control-sm"
//                           placeholder="Detailed Instructions..."
//                           rows="3" // Rows badha diye
//                           value={currentStep.description}
//                           onChange={(e) =>
//                             setCurrentStep({
//                               ...currentStep,
//                               description: e.target.value,
//                             })
//                           }
//                           style={{ minHeight: "80px", resize: "none" }} // Height 80px kar di aur resize band kiya
//                         ></textarea>
//                       </div>

//                       {/* Add Button */}
//                       <div className="col-md-12 text-end">
//                         <button
//                           className="btn btn-info rounded-pill btn-sm px-4 py-1"
//                           onClick={handleAddStep}
//                           style={{ height: "35px" }}
//                         >
//                           <i className="fas fa-plus me-1"></i> Add Step to List
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-3">
//                 <h6>Added Steps:</h6>
//                 {newExercise.steps.map((s, idx) => (
//                   <div
//                     key={idx}
//                     className="d-flex align-items-center justify-content-between border-bottom py-2"
//                   >
//                     <div className="d-flex align-items-center">
//                       <img
//                         src={getDisplayImage(s.image)}
//                         alt=""
//                         style={{
//                           width: "40px",
//                           height: "40px",
//                           objectFit: "cover",
//                           marginRight: "10px",
//                         }}
//                       />
//                       <span>
//                         {idx + 1}. {s.step_title} ({s.duration_seconds}s)
//                       </span>
//                     </div>
//                     <button
//                       className="btn btn-sm btn-danger"
//                       onClick={() => {
//                         const filtered = newExercise.steps.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setNewExercise({ ...newExercise, steps: filtered });
//                       }}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>

//               <div className="text-end mt-4">
//                 {/* Cancel Button added to match Template UI flow */}
//                 <button
//                   className="btn btn-secondary rounded-pill px-4 me-2"
//                   onClick={() => setActiveTab("list")}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="btn btn-success rounded-pill px-5"
//                   onClick={handleSaveExercise}
//                 >
//                   {isEditing ? "Update Exercise" : "Save Complete Exercise"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* VIEW MODAL */}
//       {selectedExercise && (
//         <div
//           className="modal show d-block"
//           style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}
//         >
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content border-0">
//               <div className="modal-header bg-info text-white no-print">
//                 <h5 className="modal-title">
//                   View Exercise: {selectedExercise.title}
//                 </h5>
//                 <div className="ms-auto">
//                   <button
//                     className="btn btn-sm btn-light me-2"
//                     onClick={handlePrint}
//                   >
//                     <i className="fas fa-download me-1"></i> Download/Print
//                   </button>
//                   <button
//                     className="btn-close btn-close-white shadow-none"
//                     onClick={() => setSelectedExercise(null)}
//                   ></button>
//                 </div>
//               </div>
//               <div
//                 className="modal-body p-4 bg-white print-area hide-scrollbar"
//                 style={{
//                   maxHeight: "75vh", // Screen ka 75% height lega
//                   overflowY: "auto", // Scroll enable karega
//                 }}
//               >
//                 <div className="text-center mb-4">
//                   <h2 className="text-info fw-bold">
//                     {selectedExercise.title}
//                   </h2>
//                   {selectedExercise.exercise_type && (
//                     <span className="badge bg-dark mb-2">
//                       {selectedExercise.exercise_type}
//                     </span>
//                   )}
//                   <p className="lead">{selectedExercise.description}</p>
//                   <hr />
//                 </div>
//                 <div className="row">
//                   {selectedExercise.steps.map((step) => (
//                     <div
//                       className="col-md-6 mb-4 print-full-width"
//                       key={step.id}
//                     >
//                       <div className="card h-100 border shadow-none print-row-card">
//                         <div className="p-0 text-center bg-light print-image-part">
//                           <img
//                             src={getDisplayImage(step.image)}
//                             alt={step.step_title}
//                             className="img-fluid rounded-top"
//                             style={{
//                               height: "200px",
//                               width: "100%",
//                               objectFit: "contain",
//                             }}
//                           />
//                         </div>
//                         <div className="card-body print-content-part">
//                           <div className="d-flex justify-content-between align-items-center mb-2">
//                             <h6 className="fw-bold mb-0">
//                               Step {step.step_number}: {step.step_title}
//                             </h6>
//                             <span className="badge bg-secondary">
//                               {step.duration_seconds}s
//                             </span>
//                           </div>
//                           <p
//                             className="small text-muted mb-0"
//                             style={{
//                               borderTop: "1px solid #eee",
//                               paddingTop: "10px",
//                             }}
//                           >
//                             {step.description}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="mt-4 p-3 bg-light rounded text-center only-print">
//                   <p className="mb-0">
//                     Consult your doctor if you experience any pain during these
//                     exercises.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

// {/* VIEW TEMPLATE MODAL */}
// {showViewModal && (
//   <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}>
//     <div className="modal-dialog modal-xl modal-dialog-centered">
//       <div className="modal-content border-0 shadow-lg">
        
//         {/* Modal Header */}
//         <div className="modal-header bg-info text-white">
//           <div className="d-flex align-items-center">
//             <i className="fas fa-clipboard-list fa-lg me-2"></i>
//             <h5 className="modal-title fw-bold">
//               {loadingDetails ? "Fetching Data..." : (templateDetails?.data?.template_name || templateDetails?.template_name)}
//             </h5>
//           </div>
//           <div className="ms-auto">
//             {!loadingDetails && templateDetails && (
//               <button className="btn btn-sm btn-light me-2 fw-bold rounded-pill px-3 shadow-sm" onClick={handlePrintTemplate}>
//                 <i className="fas fa-download me-1"></i> Print Plan
//               </button>
//             )}
//             <button 
//               className="btn-close btn-close-white shadow-none" 
//               onClick={() => {
//                 setShowViewModal(false);
//                 dispatch({ type: 'EXERCISE_TEMPLATE_DETAILS_RESET' });
//               }}
//             ></button>
//           </div>
//         </div>

//         {/* Modal Body */}
//         <div className="modal-body p-0 bg-light hide-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
//           {loadingDetails ? (
//             <div className="text-center py-5">
//               <div className="spinner-border text-info" role="status"></div>
//               <p className="mt-2 text-muted fw-bold">Compiling your exercise plan...</p>
//             </div>
//           ) : (templateDetails?.data || templateDetails?.template_name) ? (
//             (() => {
//               const data = templateDetails.data || templateDetails;
//               return (
//                 <div className="p-4">
//                   {/* Template Summary Card */}
//                   <div className="card border-0 shadow-sm mb-4 rounded-3 overflow-hidden">
//                     <div className="card-body bg-white border-start border-info border-5">
//                       <h6 className="text-info fw-bold text-uppercase small mb-2">Instructions & Notes</h6>
//                       <p className="mb-0 text-secondary italic fs-6">
//                         <i className="fas fa-quote-left me-2 opacity-50"></i>
//                         {data.note || "Perform these exercises in the given sequence for best results."}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Exercises Loop */}
//                   {data.exercises?.map((ex, exIdx) => (
//                     <div key={exIdx} className="mb-5">
//                       <div className="d-flex align-items-center mb-3">
//                         <div className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow" style={{ width: '40px', height: '40px', flexShrink: 0 }}>
//                           <span className="fw-bold">{exIdx + 1}</span>
//                         </div>
//                         <div>
//                           <h4 className="text-dark fw-bold mb-0">{ex.exercise_title || ex.title}</h4>
//                           <span className="badge bg-info-light text-info rounded-pill small">{ex.exercise_type || 'Exercise'}</span>
//                         </div>
//                       </div>

//                       {/* Steps Grid: Matching Single Exercise Style */}
//                       <div className="row g-3">
//                         {ex.steps?.map((step, sIdx) => (
//                           <div className="col-lg-6" key={sIdx}>
//                             <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden d-flex flex-row" style={{ minHeight: '160px' }}>
  
//   {/* Left Side: Pura image ke liye (40%) */}
//   <div style={{ width: '40%', position: 'relative', overflow: 'hidden' }} className="border-end">
//     <img 
//       src={getDisplayImage(step.image)} 
//       alt="" 
//       style={{ 
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover' // Ye image ko pure 40% area mein fill kar dega
//       }} 
//     />
//   </div>

//   {/* Right Side: Content (60%) */}
//   <div className="p-3 position-relative" style={{ width: '60%' }}>
//     <span className="position-absolute top-0 end-0 m-2 badge bg-secondary-light text-secondary">
//       {step.duration_seconds}s
//     </span>
//     <div className="text-info fw-bold small mb-1">Step {sIdx + 1}</div>
//     <h6 className="fw-bold text-dark mb-2">{step.step_title}</h6>
//     <p className="text-muted small mb-0" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
//       {step.description}
//     </p>
//   </div>
// </div>
//                           </div>
//                         ))}
//                       </div>
//                       <hr className="mt-5 opacity-5" />
//                     </div>
//                   ))}
//                 </div>
//               );
//             })()
//           ) : (
//             <div className="text-center py-5">
//               <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
//               <p className="h5">Template data could not be retrieved.</p>
//               <button className="btn btn-info mt-3" onClick={() => setShowViewModal(false)}>Close Window</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   </div>
// )}
//       {/* Custom Styles */}
//       <style>{`
//         @media screen { .only-print { display: none; } }
//         @media print {
//           @page { size: auto; margin: 10mm; }
//           .no-print { display: none !important; }
//           .modal { position: absolute !important; left: 0 !important; top: 0 !important; margin: 0 !important; padding: 0 !important; display: block !important; overflow: visible !important; }
//           .modal-dialog { max-width: 100% !important; width: 100% !important; margin: 0 !important; }
//           .modal-content { border: none !important; }
//           body { background-color: #fff !important; }
//           .print-full-width { width: 100% !important; flex: 0 0 100% !important; max-width: 100% !important; }
//           .print-row-card { display: flex !important; flex-direction: row !important; align-items: center !important; }
//           .print-image-part { width: 25% !important; border-right: 1px solid #eee; }
//           .print-content-part { width: 75% !important; text-align: left !important; }
//           .print-image-part img { height: 120px !important; width: 100% !important; object-fit: contain !important; border-radius: 0 !important; }
//           .only-print { display: block !important; }
//           hr { margin: 10px 0 !important; }
//           body * { visibility: hidden; }
//           .modal.show, .modal.show * { visibility: visible; }
//           .main-wrapper, .header, .sidebar, .footer { display: none !important; }
//         }
//         .bg-info-light { background-color: #e0f7fa; color: #00838f; padding: 5px 10px; border-radius: 4px; }
//         @media screen { .only-print { display: none; } }
//   @media print {
//     @page { size: A4; margin: 10mm; }
//     .no-print { display: none !important; }
    
//     body * { visibility: hidden; }
//     .modal.show, .modal.show * { visibility: visible; }
//     .modal { position: absolute; left: 0; top: 0; width: 100%; margin: 0; padding: 0; }
//     .modal-header, .btn, .btn-close { display: none !important; }

//     /* Layout override for 40/60 split */
//     .print-area { visibility: visible; width: 100%; }
//     .print-full-width { width: 100% !important; flex: 0 0 100% !important; max-width: 100% !important; margin-bottom: 10px; }
    
//     .print-row-card { 
//       display: flex !important; 
//       flex-direction: row !important; 
//       height: 170px !important; /* Height for ~5 per page */
//       border: 1px solid #ddd !important;
//       break-inside: avoid;
//     }
    
//     .print-image-part { 
//       width: 40% !important; 
//       height: 100% !important;
//       border-right: 1px solid #ddd !important;
//     }
    
//     .print-image-part img { 
//       height: 100% !important; 
//       width: 100% !important; 
//       object-fit: contain !important; 
//     }
    
//     .print-content-part { 
//       width: 60% !important; 
//       padding: 10px !important;
//       text-align: left !important;
//     }

//     .only-print { display: block !important; visibility: visible; }
//   }
//   .bg-info-light { background-color: #e0f7fa; color: #00838f; padding: 5px 10px; border-radius: 4px; }
//   .hide-scrollbar {
//     -ms-overflow-style: none;  /* IE and Edge */
//     scrollbar-width: none;     /* Firefox */
//   }
//   .hide-scrollbar::-webkit-scrollbar {
//     display: none;             /* Chrome, Safari, Opera */
//   }

//   @media print {
//     /* Print ke waqt scroll ki limit hatane ke liye */
//     .hide-scrollbar {
//       max-height: none !important;
//       overflow: visible !important;
//     }
//       `}</style>
//     </div>
//   );
// };

// export default ExerciseManager;


















































import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  getExercise,
  createExercise,
  updateExercise,
  deleteExercise,
} from "../../actions/exerciseAction";
import {
  listExerciseTemplates,
  deleteExerciseTemplate,
  createExerciseTemplate,
  updateExerciseTemplate,
  getExerciseTemplateById,
} from "../../actions/exerciseTemplateAction";
import { EXERCISE_TEMPLATE_RESET } from "../../actions/types";
import { imgUrl } from "../../actions/types";

const ExerciseManager = () => {
  const dispatch = useDispatch();

  const { exerciseList, hospitalID } = useSelector((state) => state.exercise);

const { 
  templates, 
  success: templateSuccess, 
  templateDetails,
  loadingDetails   
} = useSelector((state) => state.exerciseTemplates);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [isEditingTemplate, setIsEditingTemplate] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [editingStepIndex, setEditingStepIndex] = useState(null);
  const [templateFormData, setTemplateFormData] = useState({
    id: "",
    template_name: "",
    note: "",
    exercise_ids: [],
  });
  // Form State
  const [newExercise, setNewExercise] = useState({
    title: "",
    description: "",
    exercise_type: "",
    steps: [],
  });
  const [currentStep, setCurrentStep] = useState({
    step_title: "",
    description: "",
    duration_seconds: "",
    image: null,
  });

  // API Call on Mount
  // useEffect(() => {
  //   dispatch(getExercise());
  // }, [dispatch]);
  useEffect(() => {
    dispatch(getExercise());
    dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
  }, [dispatch, hospitalID]);
  // useEffect(() => {
  //   if (templateSuccess) {
  //     setShowTemplateModal(false);
  //     dispatch({ type: EXERCISE_TEMPLATE_RESET });
  //     dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
  //     alert("Template saved successfully!");
  //   }
  // }, [templateSuccess, dispatch, hospitalID]);
  // Image helper function for UI
  useEffect(() => {
  if (templateSuccess) {
    setShowTemplateModal(false);

    setActiveTab("templates"); 
    dispatch({ type: EXERCISE_TEMPLATE_RESET });
    
    dispatch(listExerciseTemplates({ hospital_id: hospitalID }));
    
    alert("Template saved successfully!");
  }
}, [templateSuccess, dispatch, hospitalID]);
const resetTemplateForm = () => {
  setTemplateFormData({
    id: "",
    template_name: "",
    note: "",
    exercise_ids: [],
  });
  setIsEditingTemplate(false);
};
  const getDisplayImage = (img) => {
    if (!img) return "https://via.placeholder.com/150";
    if (img instanceof File) return URL.createObjectURL(img); // Local Preview
    return `${imgUrl}${img}`; // API URL
  };

  // --- HANDLERS ---
  // const handleEditTemplate = (temp) => {
  //   setIsEditingTemplate(true);
  //   setTemplateFormData({
  //     id: temp.id,
  //     template_name: temp.template_name,
  //     note: temp.note,

  //     exercise_ids: temp.exercises
  //       ? temp.exercises.map((ex) => ex.exercise_id)
  //       : [],
  //   });
  //   setActiveTab("createTemplate");
  // };
// const handleEditTemplate = (temp) => {
//   setIsEditingTemplate(true);
  
 
//   const selectedIds = temp.exercises
//     ? temp.exercises.map((ex) => Number(ex.exercise_id || ex.id)) 
//     : [];

//   setTemplateFormData({
//     id: temp.id,
//     template_name: temp.template_name,
//     note: temp.note,
//     exercise_ids: selectedIds, 
//   });
  
//   setActiveTab("createTemplate");
// };
const handleEditTemplate = (temp) => {
  setIsEditingTemplate(true); 
  
  const selectedIds = temp.exercises
    ? temp.exercises.map((ex) => Number(ex.exercise_id || ex.id)) 
    : [];

  setTemplateFormData({
    id: temp.id,
    template_name: temp.template_name,
    note: temp.note,
    exercise_ids: selectedIds, 
  });
  
  setActiveTab("createTemplate"); 
};
  const handleDeleteTemplate = (id) => {
    if (window.confirm("Delete this template?")) {
      dispatch(deleteExerciseTemplate(id));
    }
  };
  // const handleToggleExerciseInTemplate = (id) => {
  //   const currentIds = templateFormData.exercise_ids || [];
  //   const isSelected = currentIds.includes(id);

  //   if (isSelected) {
  //     setTemplateFormData({
  //       ...templateFormData,
  //       exercise_ids: currentIds.filter((exId) => exId !== id),
  //     });
  //   } else {
  //     setTemplateFormData({
  //       ...templateFormData,
  //       exercise_ids: [...currentIds, id],
  //     });
  //   }
  // };
  const handleToggleExerciseInTemplate = (id) => {
  const currentIds = templateFormData.exercise_ids || [];
  const targetId = Number(id); 
  
  const isSelected = currentIds.some(existingId => Number(existingId) === targetId);

  if (isSelected) {
    setTemplateFormData({
      ...templateFormData,
      exercise_ids: currentIds.filter((exId) => Number(exId) !== targetId),
    });
  } else {
    setTemplateFormData({
      ...templateFormData,
      exercise_ids: [...currentIds, targetId],
    });
  }
};
  const handleSaveTemplate = () => {
    if (!templateFormData.template_name) return alert("Template name required");
    // Payload create karein
    const payload = {
      template_name: templateFormData.template_name,
      note: templateFormData.note,
      exercise_ids: templateFormData.exercise_ids, // Correct key name
      hospital_id: hospitalID,
      status: "Active",
    };

    if (isEditingTemplate) {
      payload.id = templateFormData.id;
      dispatch(updateExerciseTemplate(payload));
    } else {
      dispatch(createExerciseTemplate(payload));
    }
  };
  const handleDeleteExercise = (id) => {
    if (window.confirm("Are you sure you want to delete this exercise?")) {
      dispatch(deleteExercise({ id: id })).then(() => {
        dispatch(getExercise());
      });
    }
  };
const handleEditExercise = (ex) => {
  setIsEditing(true);
  setEditId(ex.id);

  // स्टेप्स को step_number के आधार पर सॉर्ट करें ताकि Index 0 हमेशा Step 1 रहे
  const sortedSteps = ex.steps ? [...ex.steps].sort((a, b) => a.step_number - b.step_number) : [];

  setNewExercise({
    title: ex.title,
    description: ex.description,
    exercise_type: ex.exercise_type || "",
    steps: sortedSteps,
  });
  setActiveTab("create");
};
  // const handleEditExercise = (ex) => {
  //   setIsEditing(true);
  //   setEditId(ex.id);
  //   setNewExercise({
  //     title: ex.title,
  //     description: ex.description,
  //     exercise_type: ex.exercise_type || "",
  //     steps: ex.steps,
  //   });
  //   setActiveTab("create");
  // };

  // const handleAddStep = () => {
  //   if (!currentStep.step_title || !currentStep.description)
  //     return alert("Fill step details");
  //   setNewExercise({
  //     ...newExercise,
  //     steps: [
  //       ...newExercise.steps,
  //       { ...currentStep, step_number: newExercise.steps.length + 1 },
  //     ],
  //   });
  //   setCurrentStep({
  //     step_title: "",
  //     description: "",
  //     duration_seconds: "",
  //     image: null,
  //   });
  // };
const handleAddStep = () => {
  if (!currentStep.step_title || !currentStep.description)
    return alert("Fill step details");

  let updatedSteps = [...newExercise.steps];

  if (editingStepIndex !== null) {
    // Preserve the original ID of the step we are editing
    const originalStep = updatedSteps[editingStepIndex];
    
    updatedSteps[editingStepIndex] = { 
      ...currentStep, 
      id: originalStep.id || null, // Keep the DB ID!
      step_number: editingStepIndex + 1 
    };
    setEditingStepIndex(null);
  } else {
    updatedSteps.push({ 
      ...currentStep, 
      step_number: updatedSteps.length + 1 
    });
  }

  setNewExercise({ ...newExercise, steps: updatedSteps });
  
  // Clear the input form
  setCurrentStep({ 
    step_title: "", 
    description: "", 
    duration_seconds: "", 
    image: null 
  });
};
const handleEditStepClick = (index) => {
  const stepToEdit = newExercise.steps[index];
  setCurrentStep({
    id: stepToEdit.id || null, // Ensure ID is captured
    step_title: stepToEdit.step_title,
    description: stepToEdit.description,
    duration_seconds: stepToEdit.duration_seconds,
    image: stepToEdit.image, // This will be a string URL
    step_number: stepToEdit.step_number
  });
  setEditingStepIndex(index); 
  window.scrollTo({ top: 400, behavior: 'smooth' });
};
  // const handleSaveExercise = () => {
  //   if (!newExercise.title) return alert("Title is required");

  //   const formData = new FormData();
  //   formData.append("title", newExercise.title);
  //   formData.append("description", newExercise.description);
  //   formData.append("exercise_type", newExercise.exercise_type);
  //   formData.append("hospitalID", hospitalID);

  //   newExercise.steps.forEach((step, index) => {
  //     formData.append(`steps[${index}][step_title]`, step.step_title);
  //     formData.append(`steps[${index}][description]`, step.description);
  //     formData.append(
  //       `steps[${index}][duration_seconds]`,
  //       step.duration_seconds,
  //     );
  //     formData.append(`steps[${index}][step_number]`, index + 1);
  //     if (step.image) formData.append(`steps[${index}][image]`, step.image);
  //   });

  //   if (isEditing) {
  //     formData.append("id", editId);
  //     dispatch(updateExercise(formData)).then((res) => {
  //       if (res.data.success) {
  //         alert("Exercise Updated!");
  //         resetForm();
  //       }
  //     });
  //   } else {
  //     dispatch(createExercise(formData)).then((res) => {
  //       if (res.data.success) {
  //         alert("Exercise Created!");
  //         resetForm();
  //       }
  //     });
  //   }
  // };
// const handleSaveExercise = () => {
//   if (!newExercise.title) return alert("Title is required");

//   const formData = new FormData();
//   formData.append("title", newExercise.title);
//   formData.append("description", newExercise.description || "");
//   formData.append("exercise_type", newExercise.exercise_type || "");
//   formData.append("hospitalID", hospitalID);

//   // Sort steps by step_number first to ensure index consistency
//   const sortedSteps = [...newExercise.steps].sort((a, b) => a.step_number - b.step_number);

//   sortedSteps.forEach((step, index) => {
//     // Pass the Step ID - Crucial for updates
//     if (step.id) {
//       formData.append(`steps[${index}][id]`, step.id);
//     }
    
//     formData.append(`steps[${index}][step_title]`, step.step_title);
//     formData.append(`steps[${index}][description]`, step.description || "");
//     formData.append(`steps[${index}][duration_seconds]`, step.duration_seconds || 0);
//     formData.append(`steps[${index}][step_number]`, index + 1);

//     // IMAGE LOGIC
//     if (step.image instanceof File) {
//       // New file upload (Binary)
//       formData.append(`steps[${index}][image]`, step.image);
//     } else if (typeof step.image === "string" && step.image !== "") {
//       // Existing image (String path)
//       // Note: If your backend deletes and re-inserts, it MUST receive this string back
//       formData.append(`steps[${index}][image]`, step.image);
//     }
//   });

//   if (isEditing) {
//     formData.append("id", editId);
//     dispatch(updateExercise(formData)).then((res) => {
//       if (res && (res.data?.success || res.success)) {
//         alert("Exercise Updated Successfully!");
//         resetForm();
//       }
//     });
//   } else {
//     dispatch(createExercise(formData)).then((res) => {
//       if (res && (res.data?.success || res.success)) {
//         alert("Exercise Created!");
//         resetForm();
//       }
//     });
//   }
// };
const handleSaveExercise = () => {
  if (!newExercise.title) return alert("Title is required");

  const formData = new FormData();
  
  // 1. Root level basic fields (Postman ke "Key" column ke mutabiq)
  if (isEditing) {
    formData.append("id", editId);
  }
  formData.append("title", newExercise.title);
  formData.append("description", newExercise.description || "");
  formData.append("hospitalID", hospitalID);
  formData.append("exercise_type", newExercise.exercise_type || "Knew");

  // 2. Steps aur Images Processing
  const stepsPayload = newExercise.steps.map((step, index) => {
    
    // IMAGE HANDLING: Agar image 'File' hai toh usey root level par append karein
    if (step.image instanceof File) {
      // Step 1 (index 0) ki image -> images[0] key mein jayegi
      formData.append(`images[${index}]`, step.image);
    }
    // Note: Agar image string (old path) hai, toh usey images[index] mein nahi bhej rahe 
    // kyunki Postman mein sirf File upload dikh raha hai.

    // STEP DATA: Isme sirf wahi fields hain jo aapke screenshot mein hain
    // 'image' key ko yahan se puri tarah hata diya gaya hai
    return {
      id: step.id || null,
      step_number: index + 1,
      step_title: step.step_title,
      description: step.description || "",
      duration_seconds: parseInt(step.duration_seconds) || 0
    };
  });

  // 3. 'steps' key mein sirf clean JSON string bhejna (without image key)
  formData.append("steps", JSON.stringify(stepsPayload));

  // 4. API Call
  const action = isEditing ? updateExercise(formData) : createExercise(formData);
  
  dispatch(action).then((res) => {
    const isSuccess = res && (res.data?.success || res.success);
    if (isSuccess) {
      alert(isEditing ? "Exercise Updated Successfully!" : "Exercise Created Successfully!");
      resetForm();
    }
  }).catch(err => {
    console.error("Payload Error:", err);
    alert("Error while saving. Check console.");
  });
};
  // const resetForm = () => {
  //   setNewExercise({
  //     title: "",
  //     description: "",
  //     exercise_type: "",
  //     steps: [],
  //   });
  //   setIsEditing(false);
  //   setEditId(null);
  //   setActiveTab("list");
  //   setEditingStepIndex(null); 
  //   dispatch(getExercise());
  // };
const resetForm = () => {
  setNewExercise({
    title: "",
    description: "",
    exercise_type: "",
    steps: [],
  });
  setCurrentStep({ // इसे भी साफ करें
    step_title: "",
    description: "",
    duration_seconds: "",
    image: null,
  });
  setIsEditing(false);
  setEditId(null);
  setEditingStepIndex(null); 
  setActiveTab("list");
  dispatch(getExercise());
};
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Exercise - ${selectedExercise.title}</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <style>
            @page { size: A4; margin: 10mm; }
            body { padding: 0; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; background: #fff; }
            .exercise-header { text-align: center; margin-bottom: 20px; border-bottom: 3px solid #00acc1; padding-bottom: 10px; }
            .exercise-header h2 { color: #00acc1; margin-bottom: 5px; font-weight: bold; }
            
            /* Main Step Row Container */
            .step-row { 
              display: flex; 
              border: 1px solid #ddd; 
              margin-bottom: 10px; 
              height: 175px; /* Fixed height to fit 5 steps per A4 page */
              break-inside: avoid; 
              overflow: hidden;
            }

            /* 40% Image Section */
            .step-image-box { 
              flex: 0 0 40%; 
              max-width: 40%; 
              background: #f8f9fa;
              border-right: 1px solid #ddd;
            }
            .step-image-box img { 
              width: 100%; 
              height: 100%; 
              object-fit: contain; 
            }

            /* 60% Content Section */
            .step-details-box { 
              flex: 0 0 60%; 
              max-width: 60%; 
              padding: 12px; 
              position: relative;
              display: flex;
              flex-direction: column;
            }

            .step-number-badge {
              background: #00acc1;
              color: white;
              padding: 2px 8px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: bold;
              margin-bottom: 5px;
              display: inline-block;
            }

            .duration-tag { 
              position: absolute; 
              top: 12px; 
              right: 12px; 
              background: #e0f7fa; 
              color: #006064;
              font-weight: bold;
              padding: 2px 8px; 
              border-radius: 4px; 
              font-size: 11px; 
            }

            .step-title { 
              font-size: 16px; 
              font-weight: bold; 
              margin-top: 5px;
              color: #333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .step-desc { 
              font-size: 12.5px; 
              color: #555; 
              line-height: 1.4;
              margin-top: 5px;
              display: -webkit-box;
              -webkit-line-clamp: 4; /* Max lines to show */
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          </style>
        </head>
        <body>
          <div class="exercise-header">
            <h2>${selectedExercise.title}</h2>
            <p class="text-muted small">${selectedExercise.description}</p>
          </div>
          ${selectedExercise.steps
            .map(
              (step, index) => `
            <div class="step-row">
              <div class="step-image-box">
                <img src="${getDisplayImage(step.image)}">
              </div>
              <div class="step-details-box">
                <span class="duration-tag">${step.duration_seconds} Seconds</span>
                <span class="step-number-badge">Step ${index + 1}</span>
                <div class="step-title">${step.step_title}</div>
                <p class="step-desc">${step.description}</p>
              </div>
            </div>
          `,
            )
            .join("")}
          <script>
            setTimeout(() => { 
              window.print(); 
              window.close(); 
            }, 750);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };
  const handlePrintTemplate = () => {
  const data = templateDetails?.data || templateDetails;
  if (!data) return;

  const printWindow = window.open("", "_blank");
  
  const exercisesHtml = data.exercises?.map((ex, exIdx) => `
    <div class="exercise-section" style="break-after: page; margin-bottom: 30px;">
      <!-- Exercise Header -->
      <div style="background: #f8f9fa; border-left: 5px solid #00acc1; padding: 15px; margin-bottom: 20px;">
        <h2 style="color: #00acc1; margin: 0; font-size: 22px;">${exIdx + 1}. ${ex.exercise_title || ex.title}</h2>
        <div style="color: #666; font-size: 14px; margin-top: 5px;">Type: ${ex.exercise_type || 'General'}</div>
        <p style="font-size: 14px; color: #444; margin-top: 8px;">${ex.description || ""}</p>
      </div>

      <!-- Steps List -->
      ${ex.steps?.map((step, index) => `
        <div class="step-row" style="display: flex; border: 1px solid #ddd; margin-bottom: 12px; min-height: 160px; break-inside: avoid;">
          <!-- 40% Image Section -->
          <div style="flex: 0 0 40%; background: #fff; display: flex; align-items: center; justify-content: center; border-right: 1px solid #ddd; padding: 5px;">
            <img src="${getDisplayImage(step.image)}" style="max-width: 100%; max-height: 150px; object-fit: contain;">
          </div>
          <!-- 60% Content Section -->
          <!-- 60% Content Section -->
<div style="flex: 0 0 60%; max-width: 60%; padding: 12px; display: flex; flex-direction: column; font-family: sans-serif; box-sizing: border-box;">
    
    <!-- Top Row: Step aur Sec ko ek line mein lane ke liye -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
        <span style="background: #00acc1; color: white; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; white-space: nowrap;">
            Step ${index + 1}
        </span>
        <span style=" font-weight: bold; padding: 2px 6px; border-radius: 4px; font-size: 11px; white-space: nowrap;">
            ${step.duration_seconds}s
        </span>
    </div>

    <!-- Title Section -->
    <div style="font-size: 15px; font-weight: bold; color: #333; line-height: 1.2; overflow: hidden; text-overflow: ellipsis;">
        ${step.step_title}
    </div>
    
    <!-- Description Section -->
    <p style="font-size: 12px; color: #555; line-height: 1.4; margin-top: 8px; margin-bottom: 0;">
        ${step.description}
    </p>
</div>
        </div>
      `).join('')}
    </div>
  `).join('');

  printWindow.document.write(`
    <html>
      <head>
        <title>Plan - ${data.template_name}</title>
        <style>
          @page { size: A4; margin: 15mm; }
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; line-height: 1.4; }
          .header-main { text-align: center; border-bottom: 4px double #00acc1; padding-bottom: 15px; margin-bottom: 25px; }
          .footer { text-align: center; font-size: 12px; color: #888; margin-top: 30px; border-top: 1px solid #eee; padding-top: 10px; }
        </style>
      </head>
      <body>
        <div class="header-main">
          <h1 style="margin: 0; color: #333; text-transform: uppercase; letter-spacing: 1px;">${data.template_name}</h1>
          <p style="margin: 5px 0; color: #666; font-style: italic;">Note: ${data.note || "Please follow the instructions carefully."}</p>
        </div>
        
        ${exercisesHtml}

        <div class="footer">
          <p>Consult your doctor if you experience any pain during these exercises.</p>
          <p>© Medisevas - Exercise Plan Generated on ${new Date().toLocaleDateString()}</p>
        </div>

        <script>
          window.onload = () => {
            setTimeout(() => { window.print(); window.close(); }, 1000);
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
};
  return (
    <div className="appointments">
      {/* Page Header */}
      <div className="page-header filter-bar rounded no-print">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="page-title">Exercise Management</h4>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/doctor/dashboard">Doctor Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Exercises</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded mt-4 no-print">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "templates" ? "active" : ""}`}
            onClick={() => setActiveTab("templates")}
          >
            Exercise Templates ({templates ? templates.length : 0})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            All Exercises ({exerciseList ? exerciseList.length : 0})
          </button>
        </li>
      </ul>

      <div className="tab-content mt-3">
        {activeTab === "templates" && (
          <div className="row">
            <div className="col-12 mb-3 text-end">
       
              <button
  className="btn btn-info rounded-pill"
  onClick={() => {
    resetTemplateForm(); 
    setActiveTab("createTemplate"); 
  }}
>
  + Create New Template
</button>
            </div>
            {templates?.map((temp) => (
  <div className="col-md-6 col-lg-4 mb-4" key={temp.id}>
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body d-flex flex-column">
        
        {/* Upper Section: Title and Status Badge */}
        <div className="d-flex justify-content-between mb-2">
          <h5 className="fw-bold text-info mb-0">{temp.template_name}</h5>
          <span className="badge bg-success">Active</span>
        </div>

        {/* Middle Section: Note/Description */}
        <p className="text-muted small mb-3">
          {temp.note ? (temp.note.length > 60 ? temp.note.substring(0, 60) + "..." : temp.note) : "No notes added"}
        </p>

        {/* Bottom Section (Fixed at bottom) */}
        <div className="mt-auto pt-3 border-top">
          <div className="d-flex justify-content-between align-items-center">
            <span className="badge bg-info-light">
              {temp.exercises?.length || 0} Exercises
            </span>
            <div className="d-flex gap-1">
             <button
  className="btn btn-sm btn-info"
  onClick={() => {
    dispatch(getExerciseTemplateById(temp.id)); 
    setShowViewModal(true); 
  }}
  title="View Template"
>
  <i className="fas fa-eye"></i>
</button>
              <button
                className="btn btn-sm btn-warning text-white"
                onClick={() => handleEditTemplate(temp)}
                title="Edit"
              >
                <i className="fas fa-edit"></i>
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteTemplate(temp.id)}
                title="Delete"
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
))}
          </div>
        )}
        {activeTab === "createTemplate" && (
          <div className="card shadow-sm">
            <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
              <span className="fw-bold">
                {isEditingTemplate ? "Edit" : "Design"} Template
              </span>
              <button
                className="btn-close btn-close-white shadow-none"
                onClick={() => setActiveTab("templates")}
              ></button>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Template Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={templateFormData.template_name}
                    onChange={(e) =>
                      setTemplateFormData({
                        ...templateFormData,
                        template_name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label>Note</label>
                  <textarea
                    className="form-control"
                    value={templateFormData.note}
                    onChange={(e) =>
                      setTemplateFormData({
                        ...templateFormData,
                        note: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>

              <h6>Select Exercises:</h6>
              <div
                className="row mt-2"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #eee",
                  padding: "10px",
                }}
              >
              
                {exerciseList?.map((ex) => {

  const isChecked = templateFormData.exercise_ids?.some(
    (id) => Number(id) === Number(ex.id)
  );

  return (
    <div className="col-md-4 mb-2" key={ex.id}>
      <div
        className={`p-2 border rounded cursor-pointer ${
          isChecked ? "bg-info-light border-info" : ""
        }`}
        onClick={() => handleToggleExerciseInTemplate(ex.id)}
      >
        <input
          type="checkbox"
          checked={isChecked} // यहाँ variable use करें
          readOnly
          className="me-2"
        />
        {ex.title}
      </div>
    </div>
  );
})}
              </div>

              <div className="text-end mt-4">
                <button
                  className="btn btn-secondary me-2"
                   onClick={() => {
    resetTemplateForm(); 
    setActiveTab("templates");
  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success px-5"
                  onClick={handleSaveTemplate}
                >
                  Save Template
                </button>
              </div>
            </div>
          </div>
        )}
        {/* TAB 1: LIST */}
        {activeTab === "list" && (
          <div className="row">
            <div className="col-12 mb-3 text-end">
              <button
                className="btn btn-info shadow-sm rounded-pill"
                onClick={() => {
                  resetForm(); // Form reset logic
                  setActiveTab("create"); // Create tab par shift
                }}
              >
                <i className="fas fa-plus me-1"></i> Create New Exercise
              </button>
            </div>
            {exerciseList &&
  exerciseList.map((ex) => (
    <div className="col-12 col-sm-6 col-lg-4 mb-4" key={ex.id}>
      <div className="card h-100 shadow-sm border-0">
        <div className="card-body d-flex flex-column">
          
          {/* Upper Section: Title and Type Badge */}
          <div className="d-flex justify-content-between mb-2">
            <h5 className="fw-bold text-info mb-0">{ex.title}</h5>
            {ex.exercise_type && (
              <span className="badge bg-secondary-light text-secondary border">
                {ex.exercise_type}
              </span>
            )}
          </div>

          {/* Middle Section: Description */}
          <p className="text-muted small mb-3">
            {ex.description ? (ex.description.length > 80 ? ex.description.substring(0, 80) + "..." : ex.description) : "No description available"}
          </p>

          {/* Bottom Section (Fixed at bottom) */}
          <div className="mt-auto pt-3 border-top">
            <div className="d-flex justify-content-between align-items-center">
              <span className="badge bg-info-light">
                {ex.steps?.length || 0} Steps
              </span>
              <div className="d-flex gap-1">
                <button
                  className="btn btn-sm btn-info"
                  onClick={() => setSelectedExercise(ex)}
                  title="View"
                >
                  <i className="fas fa-eye"></i>
                </button>
                <button
                  className="btn btn-sm btn-warning text-white"
                  onClick={() => handleEditExercise(ex)}
                  title="Edit"
                >
                  <i className="fas fa-edit"></i>
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDeleteExercise(ex.id)}
                  title="Delete"
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  ))}
          </div>
        )}

        {/* TAB 2: CREATE */}
        {activeTab === "create" && (
          <div className="card shadow-sm">
            <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
              <span className="fw-bold">
                {isEditing ? "Edit Exercise" : "Exercise Designer"}
              </span>
              <button
                type="button"
                className="btn-close btn-close-white shadow-none"
                onClick={() => setActiveTab("list")}
              ></button>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="fw-bold">Exercise Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newExercise.title}
                    onChange={(e) =>
                      setNewExercise({ ...newExercise, title: e.target.value })
                    }
                    placeholder="e.g. Knee Rehab"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-bold">Exercise Type</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. Strengthening, Yoga, Cardio..."
                    value={newExercise.exercise_type || ""}
                    onChange={(e) =>
                      setNewExercise({
                        ...newExercise,
                        exercise_type: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="fw-bold">Overall Description</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={newExercise.description}
                    onChange={(e) =>
                      setNewExercise({
                        ...newExercise,
                        description: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>

              <div className="bg-light p-2 rounded mb-3 border shadow-sm">
                <div className="row g-2 align-items-start">
                  {" "}
                  {/* align-items-start use kiya taaki upar se aligned rahein */}
                  {/* LEFT SIDE: Preview & Upload Button */}
                  <div className="col-md-3 text-center border-end pe-3">
                    <div
                      className="border rounded bg-white d-flex align-items-center justify-content-center overflow-hidden mb-1 mx-auto"
                      style={{ height: "125px", width: "100%" }} // Height thodi badhai taaki right side ke barabar dikhe
                    >
                      {currentStep.image ? (
                        <img
                          src={
                            currentStep.image instanceof File
                              ? URL.createObjectURL(currentStep.image)
                              : currentStep.image
                          }
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <div
                          className="text-muted"
                          style={{ fontSize: "10px" }}
                        >
                          <i className="fas fa-image fa-2x mb-1 opacity-25"></i>
                          <p className="small mb-0">No Image</p>
                        </div>
                      )}
                    </div>

                    {/* <input
                      type="file"
                      id="step-img-input"
                      hidden
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files[0])
                          setCurrentStep({
                            ...currentStep,
                            image: e.target.files[0],
                          });
                      }}
                    /> */}
                    <input
  type="file"
  id="step-img-input"
  hidden
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files[0];
    if (file) {
      setCurrentStep({
        ...currentStep,
        image: file, // यहाँ File Object स्टोर होगा
      });
    }
  }}
/>
                    <button
                      type="button"
                      className="btn btn-info rounded-pill btn-sm w-100 py-1 mt-1"
                      style={{ fontSize: "11px", height: "30px" }}
                      onClick={() =>
                        document.getElementById("step-img-input").click()
                      }
                    >
                      <i className="fas fa-upload me-1"></i> Upload Image
                    </button>
                  </div>
                  {/* RIGHT SIDE: Compact Fields with Matched Heights */}
                  <div className="col-md-9">
                    <div className="row g-2">
                      {/* Title Field */}
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Step Title"
                          value={currentStep.step_title}
                          onChange={(e) =>
                            setCurrentStep({
                              ...currentStep,
                              step_title: e.target.value,
                            })
                          }
                          style={{ height: "35px" }} // Fixed height
                        />
                      </div>

                      {/* Duration Field */}
                      <div className="col-md-4">
                        <div className="input-group input-group-sm">
                          {" "}
                          {/* Container height fixed */}
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Sec"
                            value={currentStep.duration_seconds}
                            onChange={(e) =>
                              setCurrentStep({
                                ...currentStep,
                                duration_seconds: e.target.value,
                              })
                            }
                            style={{ height: "35px" }} // Input height fixed
                          />
                          <span className="input-group-text py-0">sec</span>
                        </div>
                      </div>

                      {/* Textarea Field (Height Increased) */}
                      <div className="col-md-12">
                        <textarea
                          className="form-control form-control-sm"
                          placeholder="Detailed Instructions..."
                          rows="3" // Rows badha diye
                          value={currentStep.description}
                          onChange={(e) =>
                            setCurrentStep({
                              ...currentStep,
                              description: e.target.value,
                            })
                          }
                          style={{ minHeight: "80px", resize: "none" }} // Height 80px kar di aur resize band kiya
                        ></textarea>
                      </div>

                      {/* Add Button */}
                      <div className="col-md-12 text-end">
                        {/* <button
                          className="btn btn-info rounded-pill btn-sm px-4 py-1"
                          onClick={handleAddStep}
                          style={{ height: "35px" }}
                        >
                          <i className="fas fa-plus me-1"></i> Add Step to List
                        </button> */}
                        <button
  className={`btn ${editingStepIndex !== null ? 'btn-warning' : 'btn-info'} rounded-pill btn-sm px-4 py-1`}
  onClick={handleAddStep}
  style={{ height: "35px" }}
>
  <i className={`fas ${editingStepIndex !== null ? 'fa-save' : 'fa-plus'} me-1`}></i> 
  {editingStepIndex !== null ? 'Update Step' : 'Add Step to List'}
</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <h6>Added Steps:</h6>
                {newExercise.steps.map((s, idx) => (
                  <div
                    key={idx}
                    className="d-flex align-items-center justify-content-between border-bottom py-2"
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={getDisplayImage(s.image)}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          marginRight: "10px",
                        }}
                      />
                      <span>
                        {idx + 1}. {s.step_title} ({s.duration_seconds}s)
                      </span>
                    </div>
                       <button
        className="btn btn-sm btn-warning text-white me-2"
        onClick={() => handleEditStepClick(idx)}
      >
        <i className="fas fa-edit"></i> Edit
      </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        const filtered = newExercise.steps.filter(
                          (_, i) => i !== idx,
                        );
                        setNewExercise({ ...newExercise, steps: filtered });
                      }}
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>

              <div className="text-end mt-4">
                {/* Cancel Button added to match Template UI flow */}
                <button
                  className="btn btn-secondary rounded-pill px-4 me-2"
                  onClick={() => setActiveTab("list")}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success rounded-pill px-5"
                  onClick={handleSaveExercise}
                >
                  {isEditing ? "Update Exercise" : "Save Complete Exercise"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* VIEW MODAL */}
      {selectedExercise && (
        <div
          className="modal show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content border-0">
              <div className="modal-header bg-info text-white no-print">
                <h5 className="modal-title">
                  View Exercise: {selectedExercise.title}
                </h5>
                <div className="ms-auto">
                  <button
                    className="btn btn-sm btn-light me-2"
                    onClick={handlePrint}
                  >
                    <i className="fas fa-download me-1"></i> Download/Print
                  </button>
                  <button
                    className="btn-close btn-close-white shadow-none"
                    onClick={() => setSelectedExercise(null)}
                  ></button>
                </div>
              </div>
              <div
                className="modal-body p-4 bg-white print-area hide-scrollbar"
                style={{
                  maxHeight: "75vh", // Screen ka 75% height lega
                  overflowY: "auto", // Scroll enable karega
                }}
              >
                <div className="text-center mb-4">
                  <h2 className="text-info fw-bold">
                    {selectedExercise.title}
                  </h2>
                  {selectedExercise.exercise_type && (
                    <span className="badge bg-dark mb-2">
                      {selectedExercise.exercise_type}
                    </span>
                  )}
                  <p className="lead">{selectedExercise.description}</p>
                  <hr />
                </div>
                <div className="row">
                  {selectedExercise.steps.map((step) => (
                    <div
                      className="col-md-6 mb-4 print-full-width"
                      key={step.id}
                    >
                      <div className="card h-100 border shadow-none print-row-card">
                        <div className="p-0 text-center bg-light print-image-part">
                          <img
                            src={getDisplayImage(step.image)}
                            alt={step.step_title}
                            className="img-fluid rounded-top"
                            style={{
                              height: "200px",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                        <div className="card-body print-content-part">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold mb-0">
                              Step {step.step_number}: {step.step_title}
                            </h6>
                            <span className="badge bg-secondary">
                              {step.duration_seconds}s
                            </span>
                          </div>
                          <p
                            className="small text-muted mb-0"
                            style={{
                              borderTop: "1px solid #eee",
                              paddingTop: "10px",
                            }}
                          >
                            {step.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4 p-3 bg-light rounded text-center only-print">
                  <p className="mb-0">
                    Consult your doctor if you experience any pain during these
                    exercises.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

{/* VIEW TEMPLATE MODAL */}
{showViewModal && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}>
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content border-0 shadow-lg">
        
        {/* Modal Header */}
        <div className="modal-header bg-info text-white">
          <div className="d-flex align-items-center">
            <i className="fas fa-clipboard-list fa-lg me-2"></i>
            <h5 className="modal-title fw-bold">
              {loadingDetails ? "Fetching Data..." : (templateDetails?.data?.template_name || templateDetails?.template_name)}
            </h5>
          </div>
          <div className="ms-auto">
            {!loadingDetails && templateDetails && (
              <button className="btn btn-sm btn-light me-2 fw-bold rounded-pill px-3 shadow-sm" onClick={handlePrintTemplate}>
                <i className="fas fa-download me-1"></i> Print Plan
              </button>
            )}
            <button 
              className="btn-close btn-close-white shadow-none" 
              onClick={() => {
                setShowViewModal(false);
                dispatch({ type: 'EXERCISE_TEMPLATE_DETAILS_RESET' });
              }}
            ></button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="modal-body p-0 bg-light hide-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {loadingDetails ? (
            <div className="text-center py-5">
              <div className="spinner-border text-info" role="status"></div>
              <p className="mt-2 text-muted fw-bold">Compiling your exercise plan...</p>
            </div>
          ) : (templateDetails?.data || templateDetails?.template_name) ? (
            (() => {
              const data = templateDetails.data || templateDetails;
              return (
                <div className="p-4">
                  {/* Template Summary Card */}
                  <div className="card border-0 shadow-sm mb-4 rounded-3 overflow-hidden">
                    <div className="card-body bg-white border-start border-info border-5">
                      <h6 className="text-info fw-bold text-uppercase small mb-2">Instructions & Notes</h6>
                      <p className="mb-0 text-secondary italic fs-6">
                        <i className="fas fa-quote-left me-2 opacity-50"></i>
                        {data.note || "Perform these exercises in the given sequence for best results."}
                      </p>
                    </div>
                  </div>

                  {/* Exercises Loop */}
                  {data.exercises?.map((ex, exIdx) => (
                    <div key={exIdx} className="mb-5">
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-info text-white rounded-circle d-flex align-items-center justify-content-center me-3 shadow" style={{ width: '40px', height: '40px', flexShrink: 0 }}>
                          <span className="fw-bold">{exIdx + 1}</span>
                        </div>
                        <div>
                          <h4 className="text-dark fw-bold mb-0">{ex.exercise_title || ex.title}</h4>
                          <span className="badge bg-info-light text-info rounded-pill small">{ex.exercise_type || 'Exercise'}</span>
                        </div>
                      </div>

                      {/* Steps Grid: Matching Single Exercise Style */}
                      <div className="row g-3">
                        {ex.steps?.map((step, sIdx) => (
                          <div className="col-lg-6" key={sIdx}>
                            <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden d-flex flex-row" style={{ minHeight: '160px' }}>
  
  {/* Left Side: Pura image ke liye (40%) */}
  <div style={{ width: '40%', position: 'relative', overflow: 'hidden' }} className="border-end">
    <img 
      src={getDisplayImage(step.image)} 
      alt="" 
      style={{ 
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover' // Ye image ko pure 40% area mein fill kar dega
      }} 
    />
  </div>

  {/* Right Side: Content (60%) */}
  <div className="p-3 position-relative" style={{ width: '60%' }}>
    <span className="position-absolute top-0 end-0 m-2 badge bg-secondary-light text-secondary">
      {step.duration_seconds}s
    </span>
    <div className="text-info fw-bold small mb-1">Step {sIdx + 1}</div>
    <h6 className="fw-bold text-dark mb-2">{step.step_title}</h6>
    <p className="text-muted small mb-0" style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: '3', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
      {step.description}
    </p>
  </div>
</div>
                          </div>
                        ))}
                      </div>
                      <hr className="mt-5 opacity-5" />
                    </div>
                  ))}
                </div>
              );
            })()
          ) : (
            <div className="text-center py-5">
              <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
              <p className="h5">Template data could not be retrieved.</p>
              <button className="btn btn-info mt-3" onClick={() => setShowViewModal(false)}>Close Window</button>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}
      {/* Custom Styles */}
      <style>{`
        @media screen { .only-print { display: none; } }
        @media print {
          @page { size: auto; margin: 10mm; }
          .no-print { display: none !important; }
          .modal { position: absolute !important; left: 0 !important; top: 0 !important; margin: 0 !important; padding: 0 !important; display: block !important; overflow: visible !important; }
          .modal-dialog { max-width: 100% !important; width: 100% !important; margin: 0 !important; }
          .modal-content { border: none !important; }
          body { background-color: #fff !important; }
          .print-full-width { width: 100% !important; flex: 0 0 100% !important; max-width: 100% !important; }
          .print-row-card { display: flex !important; flex-direction: row !important; align-items: center !important; }
          .print-image-part { width: 25% !important; border-right: 1px solid #eee; }
          .print-content-part { width: 75% !important; text-align: left !important; }
          .print-image-part img { height: 120px !important; width: 100% !important; object-fit: contain !important; border-radius: 0 !important; }
          .only-print { display: block !important; }
          hr { margin: 10px 0 !important; }
          body * { visibility: hidden; }
          .modal.show, .modal.show * { visibility: visible; }
          .main-wrapper, .header, .sidebar, .footer { display: none !important; }
        }
        .bg-info-light { background-color: #e0f7fa; color: #00838f; padding: 5px 10px; border-radius: 4px; }
        @media screen { .only-print { display: none; } }
  @media print {
    @page { size: A4; margin: 10mm; }
    .no-print { display: none !important; }
    
    body * { visibility: hidden; }
    .modal.show, .modal.show * { visibility: visible; }
    .modal { position: absolute; left: 0; top: 0; width: 100%; margin: 0; padding: 0; }
    .modal-header, .btn, .btn-close { display: none !important; }

    /* Layout override for 40/60 split */
    .print-area { visibility: visible; width: 100%; }
    .print-full-width { width: 100% !important; flex: 0 0 100% !important; max-width: 100% !important; margin-bottom: 10px; }
    
    .print-row-card { 
      display: flex !important; 
      flex-direction: row !important; 
      height: 170px !important; /* Height for ~5 per page */
      border: 1px solid #ddd !important;
      break-inside: avoid;
    }
    
    .print-image-part { 
      width: 40% !important; 
      height: 100% !important;
      border-right: 1px solid #ddd !important;
    }
    
    .print-image-part img { 
      height: 100% !important; 
      width: 100% !important; 
      object-fit: contain !important; 
    }
    
    .print-content-part { 
      width: 60% !important; 
      padding: 10px !important;
      text-align: left !important;
    }

    .only-print { display: block !important; visibility: visible; }
  }
  .bg-info-light { background-color: #e0f7fa; color: #00838f; padding: 5px 10px; border-radius: 4px; }
  .hide-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;     /* Firefox */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;             /* Chrome, Safari, Opera */
  }

  @media print {
    /* Print ke waqt scroll ki limit hatane ke liye */
    .hide-scrollbar {
      max-height: none !important;
      overflow: visible !important;
    }
      `}</style>
    </div>
  );
};

export default ExerciseManager;
